module.exports = __webpack_public_path__ + "static/img/user_bg.b1eb381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user_bg.png
// module id = NRaT
// module chunks = 10